import CommunicationProgramManagmentForm from './CommunicationProgramManagmentForm';

export default CommunicationProgramManagmentForm;